export default __webpack_public_path__ + "static/media/What-we-do-Landing page-Website Development.688742cd.png";